import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import Pagination from "src/component/Global/Pagination"
import Helper from 'src/helper/Helper';
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import ReusableDiv from 'src/helper/ReusableDiv';
import ContentTabCommonSorting from './ContentTabCommonSorting';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';

const AllContentTab = (props) => {
    const { handleChangeTab } = props
    const [list, setList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ allTabsCount }, { get_home_page_content }, { }] = useHomePageContentStore();
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const [listObj, setListObj] = useState({ pageCount: 0, page: 1, limit: 20, sortBy: 'Relevance' });

    const { homePageAllTabs } = Constants;

    useEffect(() => {
        const fetchList = async () => {
            await fetchAPiCall(firstServerCall);
            if (firstServerCall) setFirstServerCall(false);
        };
        fetchList();
    }, [listObj.page, listObj.limit, listObj.sortBy, allTabsCount]);

    const fetchAPiCall = async (defaultStart = false) => {
        __set("CONTENT_API_CALL");
        const search_keyword = searchParams.get('search');

        const contentData = await get_home_page_content({
            pageNumber: defaultStart ? 1 : listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: search_keyword,
            contentType: homePageAllTabs.ALLCONTENT.contentType
        });

        let totalCount
        if (listObj.page == 1) {
            totalCount = contentData[homePageAllTabs.ALLCONTENT.contentType]?.totalCount - allTabsCount?.videoCount || 0;
        } else {
            totalCount = contentData[homePageAllTabs.ALLCONTENT.contentType]?.totalCount || 0;
        }

        if (totalCount > 0) {
            const totalPages = Math.ceil(totalCount / listObj.limit);
            setListObj({ ...listObj, pageCount: totalPages });
            setList(contentData[homePageAllTabs.ALLCONTENT.contentType].webContentView.filter(v => v?.avnPageType !== homePageAllTabs.VIDEO.pageType));
            setVideoList(contentData[homePageAllTabs.ALLCONTENT.contentType].webContentView.filter(v => v?.avnPageType === homePageAllTabs.VIDEO.pageType));
        } else {
            setList([]);
        }

        __remove("CONTENT_API_CALL");
    };

    const handlePageClick = (data) => {
        const newPage = data.selected + 1;
        setListObj({ ...listObj, page: newPage });
        Helper.scrollTop();
    };

    const setPageLimit = (event) => {
        const newLimit = Number(event.target.value);
        setListObj({ ...listObj, limit: newLimit, page: 1 });
    };

    const onFilter = (e) => {
        setListObj({ ...listObj, page: 1, sortBy: e.target.value })
    };

    const videoTabRedirection = () => {
        Helper.scrollTop();
        handleChangeTab(homePageAllTabs.VIDEO.abbr);
    };
    
    return (
        <div id="contentTypeAllContent" className="tab-pane fade in active">
            <div className='new-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>

                            <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.ALLCONTENT.tabHeader} dataLength={list.length} />

                            <hr />
                            {__check(['CONTENT_API_CALL', 'ALL_CONTENT_COUNT_API_CALL']).status ? <AxiosIndicatorRunTimeLoader /> :
                                <div className='position-relative'>
                                    <div className='all-content-body'>
                                        {list.length > 0 &&
                                            list.map((v, i) => (
                                                <React.Fragment key={i}>
                                                    <div className='all-content-body-item'>
                                                        <div className='bs5 row mx-0'>
                                                            <div className='col-lg-9 col-md-12 ps-0 mb-3 mb-lg-0'>
                                                                {v?.avnPageType !== homePageAllTabs.VIDEO.pageType && (
                                                                    <div className='font-16 text-blue2 font-bold mb-1'>
                                                                        <span><a href={v?.url} target="_blank">{v.name}</a></span>
                                                                        <span className='content-tag'>{v.avnPageType}</span>
                                                                    </div>
                                                                )}

                                                                {v?.avnPageType?.toLowerCase() === homePageAllTabs.ARTICLE.contentType && (<div>{Helper.dateFormatFromString(v.avnDate)}</div>)}
                                                                {v?.avnPageType !== homePageAllTabs.VIDEO.pageType && (
                                                                    <><div className='ellipses mb-1' title="">{v.shortDescription}</div><>
                                                                        {v.shortDescription?.length > 140 &&
                                                                            <a href={v?.url} className="text-blue2 d-block" target='_blank'>Read More</a>}
                                                                    </></>
                                                                )}
                                                            </div>
                                                            {v?.avnPageType?.toLowerCase() === homePageAllTabs.ARTICLE.contentType && (
                                                                <div className='col-lg-3 col-md-12 ps-0 text-start text-lg-end'>
                                                                    {v?.avnImage &&
                                                                        <div className='new-content-img'>
                                                                            <img className='img-fluid articleimage' src={v.avnImage} />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            )}
                                                            {v?.avnPageType?.toLowerCase() === homePageAllTabs.EVENT.contentType && (
                                                                <div className="date-location-box mt-2">
                                                                    <div className="date-location-item">
                                                                        <b>Date:&nbsp;</b>{Helper.dateFormatFromString(v?.avnDate)} - {Helper.dateFormatFromString(v?.updatedDate)}
                                                                    </div>
                                                                    <div className="date-location-item">
                                                                        <b>Location:&nbsp;</b> {v.avnLocation}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <hr />
                                                    </div>

                                                    {videoList.length > 0 && i === 1 && listObj.page === 1 && (
                                                        <><div className='all-content-body-item'>
                                                            <div className='bs5 row mx-0'>
                                                                {videoList.slice(0, 4).map((j, k) => (
                                                                    <div key={k} className='col-auto px-0 mb-3 mb-lg-0'>
                                                                        <div className='video-block'>
                                                                            <div className='video-iframe'>
                                                                                <iframe
                                                                                    src={j.url}
                                                                                    frameBorder='0'
                                                                                    allow='autoplay; encrypted-media'
                                                                                    allowFullScreen="allowfullscreen"
                                                                                    title='video'
                                                                                    width={200} />
                                                                            </div>
                                                                            <a href={j.url} target="_blank" className='text-blue2 font-bold d-block mt-1 text-center'>{j.name}</a>
                                                                            <div className='mb-1' title="">{j.longDescription}</div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                            {videoList.length >= 4 ?
                                                                <div className='mt-4'>
                                                                    <button className='bs5 btn btn-secondary w200' onClick={videoTabRedirection}>
                                                                        See All Videos
                                                                    </button>
                                                                </div>
                                                                : ''}<hr /></>

                                                    )}

                                                </React.Fragment>
                                            ))
                                        }
                                        {firstServerCall === false && list.length === 0 &&
                                            <NoResultContent message={`No Results Found for <b>"${searchParams.get('search')}"</b>`} />
                                        }
                                    </div>
                                    {list.length > 0 &&
                                        <div className="pagination-row mt-5">
                                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div className='col-lg-3 tab-sidebar'>
                        {ReusableDiv.newsLetterAd()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllContentTab;
